module.exports = __webpack_public_path__ + "static/img/zgmsyh.bfbf3942.png";